export default () => ({
  digitalLetters: {
    search: {
      rucOrName: "",
      status: "",
      dueFrom: "",
      dueTo: "",
      error: "",
      isLoading: false,
      data: [],
      select: {}
    },

  },

  // Vendedores (rol 5) administrados desde el panel.
  salesUsers: {
    isLoading: false,
    isSaving: false,
    data: [],
    form: {
      isOpen: false,
      isNew: true,
      id: null,
      name: "",
      email: "",
      cellphone: "",
      company_name: "faber",
      password: "",
      password_confirmation: "",
      error: "",
    },
  },

});
